// Keys here MUST stay in sync with the backend `hasPage(...)` checks in
// `src/utils/pdfs/generateLoanApp.ts`. Both sides reference these string keys
// to decide which pages of the Loan Application PDF to include.
export const applicationPdfDocumentTitles: Record<string, string> = {
  businessPurpose: 'Business Purpose Loan Application',
  disclosureStatement: 'DISCLOSURE STATEMENT AND ACKNOWLEDGEMENT FOR BUSINESS PURPOSE LOANS',
  creditAuth: 'CREDIT AUTHORIZATION FORM',
  formSsa: 'Form SSA-89',
  borrowerCertification: "Borrowers' Certification and Authorization",
}

/** Download-only options — not included in signed application / admin PDF rules. */
export const applicationPdfDownloadOnlyTitles: Record<string, string> = {
  businessPurposeNoSignature: 'Business Purpose Loan Application - No Signature Lines',
  businessPurposeFillable: 'Business Purpose Loan Application - Fillable',
}

/** Only one Business Purpose variant is generated per download. */
export const applicationPdfBusinessPurposeKeys = [
  'businessPurpose',
  'businessPurposeNoSignature',
  'businessPurposeFillable',
] as const

export const withExclusiveBusinessPurpose = (selected: string[], key: string, value: boolean) => {
  const next = value ? Array.from(new Set([...selected, key])) : selected.filter((item) => item !== key)
  if (!value || !applicationPdfBusinessPurposeKeys.includes(key as (typeof applicationPdfBusinessPurposeKeys)[number]))
    return next
  return next.filter(
    (item) =>
      item === key ||
      !applicationPdfBusinessPurposeKeys.includes(item as (typeof applicationPdfBusinessPurposeKeys)[number]),
  )
}

export const applicationPdfDocumentKeys = Object.keys(applicationPdfDocumentTitles)
export const applicationPdfDownloadOnlyKeys = Object.keys(applicationPdfDownloadOnlyTitles)
